var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13154 10.4198C6.96154 9.24975 6.07954 7.93975 5.49354 6.61075C5.36954 6.32975 5.44254 6.00075 5.65954 5.78375L6.47854 4.96575C7.14954 4.29475 7.14954 3.34575 6.56354 2.75975L5.38954 1.58575C4.60854 0.80475 3.34254 0.80475 2.56154 1.58575L1.90954 2.23775C1.16854 2.97875 0.859536 4.04775 1.05954 5.10775C1.55354 7.72075 3.07154 10.5818 5.52054 13.0308C7.96954 15.4798 10.8305 16.9978 13.4435 17.4918C14.5035 17.6918 15.5725 17.3828 16.3135 16.6418L16.9645 15.9908C17.7455 15.2098 17.7455 13.9438 16.9645 13.1628L15.7915 11.9897C15.2055 11.4037 14.2555 11.4037 13.6705 11.9897L12.7675 12.8938C12.5505 13.1108 12.2215 13.1837 11.9405 13.0597C10.6115 12.4727 9.30154 11.5898 8.13154 10.4198Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.2eb227de.svg";
export { ForwardRef as ReactComponent };